import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/toastError.svg',
})
export class ToastErrorComponent {}
